import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgVitaminCSerumGlyphSecondary from './svgs/VitaminCSerumGlyphSecondary.js';
import SvgVitaminCSerumGlyph from './svgs/VitaminCSerumGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var vitaminCSerumGlyph = (props => useIcon(SvgVitaminCSerumGlyph, SvgVitaminCSerumGlyphSecondary, props));

export { vitaminCSerumGlyph as default };
